import { ApiType } from "@gymflow/common";
import { ApiListResponse, UserStaffBean } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export async function staffListQueryFn({
  api,
  opts,
}: {
  api: ApiType;
  opts?: Parameters<ApiType["staffApi"]["find"]>[0];
}) {
  return (
    await api.staffApi.find({
      ...opts,
    })
  ).data;
}

export function useStaffList(
  {
    api,
    opts,
  }: {
    api: ApiType;
    opts?: Parameters<ApiType["staffApi"]["find"]>[0];
  },
  queryOpts?: Omit<UseQueryOptions<ApiListResponse<UserStaffBean>>, "queryKey">,
) {
  return useQuery({
    queryKey: staffQueryKeys.list(opts),
    queryFn: () => {
      return staffListQueryFn({ api, opts });
    },
    ...queryOpts,
  });
}
